// apps/account-portal/src/stores/boardStore.ts
import { boardApi } from '../services/api';
import { createFeedStore } from '@redpanda/utils';

export type PostType = 'GENERAL' | 'FEEDBACK' | 'BUG';
export const POST_TYPES: PostType[] = ['GENERAL', 'FEEDBACK', 'BUG'];

export interface BoardPost {
  id: string;
  /** 是不是自己發的（後端判斷；公開 API 不回傳作者 id） */
  isMine: boolean;
  authorName: string;
  postType: PostType;
  title: string;
  content: string;
  isPinned: boolean;
  adminReply: string | null;
  adminReplyAt: string | null;
  likeCount: number;
  userHasLiked: boolean;
  commentCount: number;
  createdAt: string;
}

export interface BoardComment {
  id: string;
  postId: string;
  /** 是不是自己發的（後端判斷；公開 API 不回傳作者 id） */
  isMine: boolean;
  authorName: string;
  content: string;
  isEdited: boolean;
  editedAt: string | null;
  createdAt: string;
}

/** 置頂在前、新的在前（留言不需要依讚數排序） */
export const useBoardStore = createFeedStore<BoardPost>('board-feed', async ({ page, filter, q }) => {
  const { data } = await boardApi.getPosts({ page, pageSize: 20, type: filter || undefined, q: q || undefined });
  return data;
}, { sort: 'new' }, { filters: POST_TYPES });
